export enum FilterProviderKey {
	FILTER_PROVIDER = 'filterProvider',
	CURRENCY_FILTER_PROVIDER = 'currencyFilterProvider',
	LOCATION_FILTER_PROVIDER = 'locationFilterProvider'
}
